import service from '@/utils/request'
import { BASE_FILE_URL, BASE_URL } from '@/config/env'
import axios from 'axios'
import { Loading } from 'element-ui'

/**
 * 公用API
 */
export function httpRequest (params) {
  return service.request({
    url: (params.baseUrl || BASE_URL) + params.url,
    method: params.method || 'get',
    data: params.data || {},
    params: params.data || {}
  })
}

/**
 * post方法
 * @param url
 * @param data
 * @param headers
 * @returns {Promise<AxiosResponse<any>>}
 * @constructor
 */
export function Post (url, data, headers = {}) {
  return service.request({
    url: BASE_URL + url,
    method: 'post',
    data: data || {},
    headers
  })
}

/**
 * put方法
 * @param url
 * @param data
 * @param headers
 * @returns {Promise<AxiosResponse<any>>}
 * @constructor
 */
export function Put (url, data, headers = {}) {
  return service.request({
    url: BASE_URL + url,
    method: 'put',
    data: data || {},
    headers
  })
}

/**
 * patch方法
 * @param url
 * @param data
 * @param headers
 * @returns {Promise<AxiosResponse<any>>}
 * @constructor
 */
export function Patch (url, data, headers = {}) {
  return service.request({
    url: BASE_URL + url,
    method: 'patch',
    data: data || {},
    headers
  })
}

/**
 * Get方法
 * @param url
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 * @constructor
 */
export function Get (url, data) {
  return service.request({
    url: BASE_URL + url,
    method: 'get',
    params: data || {}
  })
}

/**
 * delete方法
 * @param url
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 * @constructor
 */
export function Delete (url, data) {
  return service.request({
    url: BASE_URL + url,
    method: 'delete',
    data: data || {}
  })
}

/**
 * 导出文件
 * @param url
 * @param title
 * @param data
 * @param type
 * @returns {Promise<AxiosResponse<any>>}
 * @constructor
 */
export function ExportExcel (url, data, title, type) {
  type = type || 'application/x-xls'
  return service.request({
    url: BASE_URL + url, // 接口路径
    responseType: 'arraybuffer', // 下载需要添加类型，否则会乱码
    method: 'POST', // 请求方法
    data: data || {}
  }).then(content => {
    const blob = new Blob([content], { type })
    const fileName = title + '.xls'
    if ('download' in document.createElement('a')) {
      // 非IE下载
      const elink = document.createElement('a')
      elink.download = fileName
      elink.style.display = 'none'
      elink.href = URL.createObjectURL(blob)
      document.body.appendChild(elink)
      elink.click()
      URL.revokeObjectURL(elink.href) // 释放URL 对象
      document.body.removeChild(elink)
    } else {
      // IE10+下载
      navigator.msSaveBlob(blob, fileName)
    }
  })
}

/**
 * 访问静态文件
 * @param url
 * @param fileName
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 * @constructor
 */
export function GetDown (url, fileName, params) {
  const loadMsg = Loading.service('加载中')
  return axios.request({
    url: BASE_FILE_URL + url,
    method: 'get',
    params: params || {},
    responseType: 'blob'
  }).then(content => {
    loadMsg.close()
    const blob = new Blob([content.data], { type: 'application/octet-stream' })
    if ('download' in document.createElement('a')) {
      // 非IE下载
      const elink = document.createElement('a')
      elink.download = fileName
      elink.style.display = 'none'
      elink.href = URL.createObjectURL(blob)
      document.body.appendChild(elink)
      elink.click()
      URL.revokeObjectURL(elink.href) // 释放URL 对象
      document.body.removeChild(elink)
    } else {
      // IE10+下载
      navigator.msSaveBlob(blob, fileName)
    }
  })
}
